module.exports = __webpack_public_path__ + "media/src/images/logos/brics-0cd5b42fa5b404254776ac1c62340ea5.svg";